// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"abca96e2","465":"29d7ae40"}[chunkId] + ".chunk.css";
};